import './App.css';
import React from '.';
import { Menu, MenuItem, Sidebar } from 'react-pro-sidebar';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { Button, Form } from 'react-bootstrap';
import 'react-bootstrap-table/dist/react-bootstrap-table.min.css';
import { Suspense, lazy, useEffect, useRef } from 'react';
import { useAlert } from 'react-alert';

// 라우트 단위 코드 스플리팅: 각 화면은 해당 경로로 이동할 때 별도 청크로
// 받아온다. 아래 컴포넌트는 전부 <Route element>로만 쓰이므로 지연 로딩해도
// 초기 렌더에 영향이 없다. 정적 import로 되돌리면 main 번들로 다시 합쳐진다.
const Emiratepost = lazy(() => import('component/emiratepost'));
const Home = lazy(() => import('./component/home'));
const Postnl = lazy(() => import('./component/postnl'));
const Temp = lazy(() => import('./component/temp'));
const TrackingUp = lazy(() => import('./component/trackingUp'));
const Tracking = lazy(() => import('./component/tracking'));
const Jnt_sg = lazy(() => import('./component/jnt_sg'));
const Redpack = lazy(() => import('./component/redpack'));
const Ubi = lazy(() => import('./component/ubi'));
const Ysl = lazy(() => import('./component/ysl'));
const Landmark = lazy(() => import('./component/landmark'));
const Parcll = lazy(() => import('./component/parcll'));
const Gls = lazy(() => import('./component/gls'));
const Kwt = lazy(() => import('./component/kwt'));
const Pplus = lazy(() => import('./component/pplus'));
const Bagging = lazy(() => import('./component/bagging'));
const Setting = lazy(() => import('./component/setting'));
const Order = lazy(() => import('./component/order'));
const Packing = lazy(() => import('./component/packing'));
const Track = lazy(() => import('./component/track'));
const Scan = lazy(() => import('./component/scan'));
const Temp_bag = lazy(() => import('./component/temp_bag'));
const Bxb = lazy(() => import('./component/bxb'));
const Frayun = lazy(() => import('./component/frayun'));
const Dai = lazy(() => import('./component/dai'));
const Hispa = lazy(() => import('./component/hispa'));
const Scan_ysl = lazy(() => import('./component/scan_ysl'));
const New_setting = lazy(() => import('./component/new_setting'));
const Kpost = lazy(() => import('./component/kpost'));
const Omniva = lazy(() => import('./component/omniva'));
const Kstar_shipter = lazy(() => import('./component/kstar_shipter'));
const Bxb_pack = lazy(() => import('./component/bxb_pack'));
const Parcll_pack = lazy(() => import('./component/parcll_pack'));
const Aramex = lazy(() => import('./component/aramex'));
const Bag_packing = lazy(() => import('./component/bag_packing'));
const Bag_move = lazy(() => import('./component/bag_move'));
const Other_pack = lazy(() => import('./component/other_pack'));
const Uniuni = lazy(() => import('./component/uniuni'));
const Uskaka = lazy(() => import('./component/uskaka'));
const Packing_shipter = lazy(() => import('./component/proc/packing_shipter'));
const Update_weight = lazy(() => import('./component/proc/update_weight'));
const Asendia = lazy(() => import('./component/asendia'));
const Esupply = lazy(() => import('./component/esupply'));
const Qp_express = lazy(() => import('./component/qp_express'));
const Rsa = lazy(() => import('./component/rsa'));
const Floship = lazy(() => import('./component/floship'));
const Gvend = lazy(() => import('./component/gvend'));
const Partner_proc = lazy(() => import('./component/partner_proc'));
const Cargo = lazy(() => import('./component/pages/Cargo'));
const Inpost = lazy(() => import('./component/inpost'));
const Skynet = lazy(() => import('./component/skynet'));
const Gbs = lazy(() => import('./component/gbs'));
const ReceiptReview = lazy(() => import('./component/receipts/ReceiptReview'));
const MachineDashboard = lazy(() => import('./component/receipts/MachineDashboard'));
const Shipero = lazy(() => import('./component/shipero'));
const MasterConsolidation = lazy(() => import('./component/receipts/MasterConsolidation'));
const MasterManage = lazy(() => import('./component/receipts/MasterManage'));

// import { Partner, USPack } from './component/pages';

// import Ws from "./component/ws";
// 라우트 청크를 받아오는 동안 보여줄 화면. 라벨/스캔 작업 중
// 레이아웃이 튀지 않도록 사이드바 오른쪽 영역만 채운다.
function RouteFallback() {
    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
                height: '100%',
                minHeight: '200px',
                color: '#888',
                fontSize: '14px',
            }}
        >
            불러오는 중...
        </div>
    );
}

function App() {
    const alert = useAlert();
    const navigate = useNavigate();
    const location = useLocation();

    const idInputRef = useRef(null);
    const pwInputRef = useRef(null);

    const apiList = [

        // {icon : require('img/logo_img.png'), key : 'temp_bag', show_key : 'BAG',},
        // {icon : require('img/logo_img.png'), key : 'kwt_scan', show_key : 'KWT-B',},
        // { icon: require('img/logo_img.png'), key: 'tmp_log', show_key: 'TMP_LOG' },
        { icon: require('img/logo_img.png'), key: 'master', show_key: 'MASTER' },
        { icon: require('img/logo_img.png'), key: 'review', show_key: 'REVEIW' },
        { icon: require('img/logo_img.png'), key: 'machine', show_key: 'MACHINE' },
        { icon: require('img/logo_img.png'), key: 'list', show_key: 'LIST' },

        // { icon: require('img/logo_img.png'), key: 'api', show_key: 'API' },
        // { icon: require('img/logo_img.png'), key: 'track', show_key: 'TRACK' },
        // {icon : require('img/logo_img.png'), key : 'scan_yt', show_key : 'SCAN_YT',},

        // {icon : require('img/logo_img.png'), key : 'bagging', show_key : 'BAGGING',},
        // {icon: require('img/logo_img.png'), key: 'setting', show_key: 'SETTING',},

        // {
        //     icon: require('img/logo_img.png'),
        //     key: 'new_setting',
        //     show_key: 'UPDATE_1',
        // },
        // {
        //     icon: require('img/logo_img.png'),
        //     key: 'bag_packing',
        //     show_key: 'UPDATE_2',
        // },
        { icon: require('img/logo_img.png'), key: 'temp', show_key: 'SCAN' },
        {
            icon: require('img/logo_img.png'),
            key: 'update_weight',
            show_key: 'UPDATE_3',
        },

        {
            icon: require('img/logo_img.png'),
            key: 'packing',
            show_key: 'PACKING',
        },
        {
            icon: require('img/logo_img.png'),
            key: 'packing_shipter',
            show_key: 'PACKING_2',
        },

        {
            icon: require('img/logo_img.png'),
            key: 'bag_move',
            show_key: 'BAG MOVE',
        },
        // {icon : require('img/logo_img.png'), key : 'order', show_key : 'ORDER',},
        {
            icon: require('img/logo_img.png'),
            key: 'kstar_shipter',
            show_key: 'SHIPTER_UP',
        },
        {
            icon: require('img/logo_img.png'),
            key: 'bxb_pack',
            show_key: 'BXB_PACK',
        },
        {
            icon: require('img/logo_img.png'),
            key: 'other_pack',
            show_key: 'OTH_PACK',
        },
        {
            icon: require('img/logo_img.png'),
            key: 'us_pack',
            show_key: 'US_PACK',
        },
        {
            icon: require('img/logo_img.png'),
            key: 'cargo',
            show_key: 'CARGO',
        },

        // {icon : require('img/icon_ysl.jpeg'), key : 'ysl', show_key : 'YSL',},
        // {icon : require('img/icon_hispa.png'), key : 'hispa', show_key : 'HISPA',},
        // {icon : require('img/icon_dai.png'), key : 'dai', show_key : 'DAI',},
        // {icon : require('img/icon_frayun.png'), key : 'frayun', show_key : 'FRAYUN',},
        // {icon : require('img/icon_bxb.png'), key : 'bxb', show_key : 'BXB',},
        // {icon : require('img/icon_kwt.png'), key : 'kwt', show_key : 'KWT',},
        // // {icon : require('img/icon_kwt.png'), key : 'kwt_bag', show_key : 'KWT(BAG)',},
        //
        // // {icon : require('img/icon_cacesa.png'), key : 'cacesa', show_key : 'CACESA',},
        // {icon : require('img/icon_gls.png'), key : 'gls', show_key : 'GLS',},
        // {icon : require('img/icon_parcll.png'), key : 'parcll', show_key : 'PARCLL',},
        // { icon: require('img/icon_inpost.png'), key: '14', show_key: '14' },
        // {icon : require('img/icon_landmark.png'), key : 'landmark', show_key : 'BPOST',},
        //
        // {icon : require('img/icon_ubi.png'), key : 'ubi', show_key : 'UBI',},
        // // {icon : require('img/icon_ubi.png'), key : 'ubi_bag', show_key : 'UBI(BAG)',},
        // // {icon : require('img/icon_usps.png'), key : 'usps', show_key : 'USPS',},
        // {icon : require('img/icon_redpack.png'), key : 'redpack', show_key : 'REDPACK',},
        // {icon : require('img/icon_em.jpg'), key : 'emiratepost', show_key : 'EMIRATE',},
        // // {icon : require('img/icon_brt.jpg'), key : 'brtpost', show_key : 'BRT',},
        // {icon : require('img/icon_postnl.jpeg'), key : 'postnl', show_key : 'POSTNL',},
        // // {icon : require('img/icon_ampm.jpg'), key : 'ampm', show_key : 'AMPM',},
        // // {icon : require('img/icon_jnt.png'), key : 'jnt', show_key : 'J&T',},
        // // {icon : require('img/icon_jnt.png'), key : 'jnt_sg', show_key : 'J&T SG',}
        // { icon: require('img/logo_img.png'), key: '33', show_key: '33' },
        // { icon: require('img/logo_img.png'), key: '32', show_key: '32' },
        { icon: require('img/logo_img.png'), key: '30', show_key: '30' },
        { icon: require('img/logo_img.png'), key: '4', show_key: '4' },

        // { icon: require('img/logo_img.png'), key: '27', show_key: '27' },
        // { icon: require('img/logo_img.png'), key: '26', show_key: '26' },
        // { icon: require('img/icon_ysl.jpeg'), key: '25', show_key: '25' },
        // { icon: require('img/icon_hispa.png'), key: '22', show_key: '22' },
        // { icon: require('img/icon_dai.png'), key: '23', show_key: '23' },
        // { icon: require('img/icon_frayun.png'), key: '21', show_key: '21' },
        { icon: require('img/icon_bxb.png'), key: '20', show_key: '20' },
        // { icon: require('img/icon_kwt.png'), key: '17', show_key: '17' },
        // {icon : require('img/icon_kwt.png'), key : 'kwt_bag', show_key : 'KWT(BAG)',},

        // {icon : require('img/icon_cacesa.png'), key : 'cacesa', show_key : 'CACESA',},
        // { icon: require('img/icon_gls.png'), key: '16', show_key: '16' },
        // { icon: require('img/icon_parcll.png'), key: '15', show_key: '15' },
        // {icon : require('img/icon_inpost.png'), key : '14', show_key : '14'},
        // { icon: require('img/icon_landmark.png'), key: '19', show_key: '19' },

        { icon: require('img/icon_ubi.png'), key: '5', show_key: '5' },
        // {icon : require('img/icon_ubi.png'), key : 'ubi_bag', show_key : 'UBI(BAG)',},
        // {icon : require('img/icon_usps.png'), key : 'usps', show_key : 'USPS',},
        // { icon: require('img/icon_redpack.png'), key: '7', show_key: '7' },
        // { icon: require('img/icon_em.jpg'), key: '3', show_key: '3' },
        // {icon : require('img/icon_brt.jpg'), key : 'brtpost', show_key : 'BRT',},
        // { icon: require('img/icon_postnl.jpeg'), key: '2', show_key: '2' },
        // {icon : require('img/icon_ampm.jpg'), key : 'ampm', show_key : 'AMPM',},
        // {icon : require('img/icon_jnt.png'), key : 'jnt', show_key : 'J&T',},
        // { icon: require('img/icon_jnt.png'), key: '10', show_key: '10' },

        { icon: require('img/logo_img.png'), key: '35', show_key: '35' },
        // { icon: require('img/logo_img.png'), key: '36', show_key: '36' },
        { icon: require('img/logo_img.png'), key: '37', show_key: '37' },
        { icon: require('img/logo_img.png'), key: '38', show_key: '38' },
        // { icon: require('img/logo_img.png'), key: '40', show_key: '40' },
        { icon: require('img/logo_img.png'), key: '42', show_key: '42' },
        { icon: require('img/logo_img.png'), key: '54', show_key: '54' },
        { icon: require('img/logo_img.png'), key: '55', show_key: '55' },
        { icon: require('img/logo_img.png'), key: '58', show_key: '58' },

    ];

    const goToAdmin = async () => {
        try {
            const response = await fetch(
                'https://shiptertracking.com:3963/auth/sign-in',
                {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({
                        id: idInputRef.current?.value ?? '',
                        password: pwInputRef.current?.value ?? '',
                    }),
                },
            );
            const json = await response.json();
            if (!json.suc) throw new Error();

            return true;
        } catch (error) {
            console.error(error);
            alert.error('잘못된 아이디와 비밀번호 입니다.');
            return false;
        }
    };

    useEffect(() => {
        // if(width < 800){
        //     collapseSidebar();
        // }
        // if(location.state != 'adminChk'){
        //     // navigate('/')
        // }
        // console.log("Hostname:", window.location.hostname);
        if(window.location.hostname == 'localhost'){
            navigate(location.pathname, {
                state: 'adminChk',
            });
        }
    }, []);

    if (location.state != 'adminChk') {
        return (
            <div
                style={{
                    width: '100vw',
                    height: '100vh',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}
            >
                <div style={{ width: 400, textAlign: 'center' }}>
                    <h1>ADMIN MODE</h1>
                    <div
                        style={{
                            margin: '20px 0px',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 8,
                        }}
                    >
                        <Form.Control
                            autoFocus
                            ref={idInputRef}
                            name='id'
                            defaultValue={null}
                            placeholder='관리자 아이디를 입력하세요'
                            onKeyUp={(e) => {
                                if (e.key === 'Enter') {
                                    pwInputRef.current?.focus();
                                }
                            }}
                        />
                        <Form.Control
                            ref={pwInputRef}
                            type='password'
                            name='password'
                            defaultValue={null}
                            placeholder='관리자 비밀번호를 입력하세요'
                            onKeyUp={async (e) => {
                                if (e.key === 'Enter') {
                                    goToAdmin().then((res) => {
                                        if (res) {
                                            navigate(location.pathname, {
                                                state: 'adminChk',
                                            });
                                        }
                                    });
                                }
                            }}
                        />
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'center',
                        }}
                    >
                        <Button
                            style={{ width: 160 }}
                            variant={'dark'}
                            onClick={() => {
                                // this.handleClickDelete();
                                // onClose();
                                goToAdmin().then((res) => {
                                    if (res) {
                                        navigate(location.pathname, {
                                            state: 'adminChk',
                                        });
                                    }
                                });
                            }}
                        >
                            확인
                        </Button>
                    </div>
                </div>
            </div>
        );
    } else {
        // review/machine/master 는 사이드바 없이 전체화면으로 보고
        // 상단 "← 메뉴" 버튼으로 메뉴(홈)로 돌아간다.
        const isFullScreen = ['/review', '/machine', '/list', '/master', '/tmp_log']
            .includes(location.pathname)

        return (
            <div style={{ display: 'flex', height: '100vh' }}>
                {!isFullScreen && (
                <Sidebar width={'180px'}>
                    {/*<Menu style={{backgroundColor:'gray'}}>*/}
                    {/*  <MenuItem> HOME</MenuItem>*/}
                    {/*</Menu>*/}
                    <Menu>
                        {apiList
                            .sort((a, b) =>
                                parseInt(a.show_key) > parseInt(b.show_key) ||
                                isNaN(b.show_key)
                                    ? 1
                                    : -1,
                            )
                            .map((m, i) => {
                                return (
                                    <MenuItem
                                        style={{
                                            // borderBottom: i == 2 ? '1px solid white' : 0,
                                            // marginTop: i == 6 ? 100 : 0,
                                            backgroundColor:
                                                location.pathname ==
                                                '/' + m['key']
                                                    ? 'white'
                                                    : 'transparent',
                                            color:
                                                location.pathname ==
                                                '/' + m['key']
                                                    ? 'gray'
                                                    : 'white',
                                        }}
                                        key={i}
                                              icon={
                                            i < 5 && <div style={{backgroundColor:'white', padding:'0px 2px', marginRight:5}}>
                                                <img src={m['icon']} alt={''} width={30} />
                                            </div>
                                        }
                                        onClick={() =>
                                            navigate('/' + m['key'], {
                                                state: 'adminChk',
                                            })
                                        }
                                    >
                                        {' '}
                                        {m['show_key']}
                                    </MenuItem>
                                );
                            })}
                    </Menu>
                </Sidebar>
                )}
                <div
                    style={{
                        width: '100%',
                        height: '100vh',
                        overflowY: 'auto',
                    }}
                >
                    <Suspense fallback={<RouteFallback />}>
                        <Routes>
                        <Route
                            path={'/review'}
                            element={<ReceiptReview /> }
                        />
                        <Route
                            path={'/machine'}
                            element={<MachineDashboard /> }
                        />

                        <Route
                            path={'/list'}
                            element={<MasterConsolidation /> }
                        />

                        {/*
                          * 마스터 관리 — 항공편/MAWB 등 마스터 자체 정보를
                          * 엑셀처럼 셀 단위로 고치는 화면. /list 는 백을
                          * 마스터로 묶는 흐름이라 축이 다르다.
                          */}
                        <Route
                            path={'/master'}
                            element={<MasterManage /> }
                        />

                        <Route
                            path={'/'}
                            element={<Home apiList={apiList} />}
                        />
                        <Route
                            path={'/home'}
                            element={<Home apiList={apiList} />}
                        />
                        <Route
                            path={'/api'}
                            element={<Partner_proc />}
                        />
                        <Route
                            path={'/track'}
                            element={<Track />}
                        />
                        <Route
                            path={'/bagging'}
                            element={<Bagging />}
                        />
                        <Route
                            path={'/setting'}
                            element={<Setting />}
                        />
                        <Route
                            path={'/order'}
                            element={<Order />}
                        />
                        <Route
                            path={'/packing'}
                            element={<Packing />}
                        />
                        <Route
                            path={'/test'}
                            element={<Scan />}
                        />
                        <Route
                            path={'/kstar_shipter'}
                            element={<Kstar_shipter />}
                        />
                        <Route
                            path={'/bxb_pack'}
                            element={<Bxb_pack />}
                        />
                        <Route
                            path={'/other_pack'}
                            element={<Other_pack />}
                        />
                        <Route
                            path={'/scan_yt'}
                            element={<Scan_ysl />}
                        />
                        <Route
                            path={'/us_pack'}
                            element={<Parcll_pack />}
                        />
                        <Route
                            path={'/bag_packing'}
                            element={<Bag_packing />}
                        />
                        <Route
                            path={'/new_setting'}
                            element={<New_setting />}
                        />
                        <Route
                            path={'/bag_move'}
                            element={<Bag_move />}
                        />
                        <Route
                            path={'/update_weight'}
                            element={<Update_weight />}
                        />
                        <Route
                            path='/cargo'
                            element={<Cargo />}
                        />
                        {/*<Route*/}
                        {/*    path={'/partner'}*/}
                        {/*    element={<Partner />}*/}
                        {/*/>*/}
                        {/*<Route*/}
                        {/*    path={'/us-pack'}*/}
                        {/*    element={<USPack />}*/}
                        {/*/>*/}
                        <Route
                            path={'/33'}
                            element={<Uskaka />}
                        />
                        <Route
                            path={'/32'}
                            element={<Uniuni />}
                        />
                        <Route
                            path={'/30'}
                            element={<Aramex />}
                        />
                        <Route
                            path={'/4'}
                            element={<Pplus />}
                        />
                        <Route
                            path={'/27'}
                            element={<Omniva />}
                        />
                        <Route
                            path={'/22'}
                            element={<Hispa />}
                        />
                        <Route
                            path={'/23'}
                            element={<Dai />}
                        />

                        <Route
                            path={'/21'}
                            element={<Frayun />}
                        />
                        <Route
                            path={'/20'}
                            element={<Bxb />}
                        />
                        <Route
                            path={'/17'}
                            element={<Kwt />}
                        />
                        <Route
                            path={'/16'}
                            element={<Gls />}
                        />
                        <Route
                            path={'/25'}
                            element={<Ysl />}
                        />
                        <Route
                            path={'/19'}
                            element={<Landmark />}
                        />
                        <Route
                            path={'/5'}
                            element={<Ubi />}
                        />
                        <Route
                            path={'/7'}
                            element={<Redpack />}
                        />
                        <Route
                            path={'/2'}
                            element={<Postnl />}
                        />
                        <Route
                            path={'/26'}
                            element={<Kpost />}
                        />
                        <Route
                            path={'/35'}
                            element={<Asendia />}
                        />
                        <Route
                            path={'/36'}
                            element={<Esupply />}
                        />
                        <Route
                            path={'/37'}
                            element={<Qp_express />}
                        />
                        <Route
                            path={'/38'}
                            element={<Rsa />}
                        />
                        <Route
                            path={'/40'}
                            element={<Floship />}
                        />
                        <Route
                            path={'/42'}
                            element={<Gvend />}
                        />
                        {/*<Route path={'/kwt_bag'} element={<Kwt_bag />}/>*/}
                        {/*<Route path={'/cacesa'} element={<Cacesa />}/>*/}
                        <Route
                            path={'/15'}
                            element={<Parcll />}
                        />
                        <Route
                            path={'/14'}
                            element={<Inpost />}
                        />

                        <Route
                            path={'/54'}
                            element={<Skynet />}
                        />
                        <Route
                            path={'/55'}
                            element={<Gbs />}
                        />
                        <Route
                            path={'/58'}
                            element={<Shipero />}
                        />

                        {/*<Route path={'/ubi_bag'} element={<Ubi_bag />}/>*/}
                        {/*<Route path={'/usps'} element={<Usps />}/>*/}
                        <Route
                            path={'/3'}
                            element={<Emiratepost />}
                        />
                        {/*<Route path={'/brtpost'} element={<Brtpost/>}/>*/}
                        {/*<Route path={'/ampm'} element={<Ampm />}/>*/}
                        {/*<Route path={'/jnt'} element={<Jnt />}/>*/}
                        <Route
                            path={'/10'}
                            element={<Jnt_sg />}
                        />
                        <Route
                            path={'/temp'}
                            element={<Temp />}
                        />
                        {/*<Route path={'/kwt_scan'} element={<Kwt_scan />}/>*/}
                        <Route
                            path={'/temp_bag'}
                            element={<Temp_bag />}
                        />
                        {/*<Route path={'/ws'} element={<Ws />}/>*/}
                        <Route
                            path={'/trackingUp'}
                            element={<TrackingUp />}
                        />
                        <Route
                            path={'/tracking'}
                            element={<Tracking />}
                        />
                        <Route
                            path={'/packing_shipter'}
                            element={<Packing_shipter />}
                        />
                        </Routes>
                    </Suspense>
                </div>
                {/*<Outlet>*/}
                {/*    <Router>*/}
                {/*        <Routes>*/}
                {/*            <Route path={'/'} element={<Emiratepost/>}/>*/}
                {/*        </Routes>*/}
                {/*    </Router>*/}
                {/*</Outlet>*/}
            </div>
        );
    }
}

export default App;
